import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewerTestFiltersGroupMatchDisplay = props => {
  const {
    matchStatus,
    objectName
  } = props;
  return /*#__PURE__*/_jsx(View, {
    marginInlineStart: "300",
    as: "div",
    children: /*#__PURE__*/_jsx("b", {
      children: matchStatus === 'PASS' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.testFiltersAssociationGroup.passes",
        options: {
          objectType: objectName
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.testFiltersAssociationGroup.fails",
        options: {
          objectType: objectName
        }
      })
    })
  });
};
export default ViewerTestFiltersGroupMatchDisplay;